import React, { useEffect, useState } from "react";
import MdaeDrawer from "../common_widgets/drawer";
import $ from "jquery";
import MdaeKanban from "../common_widgets/kanban/component";
import MdaeScrollView from "../common_widgets/scroll-view";
import { useSelector, useDispatch } from "react-redux";
import TaskCard, { GetFormatedDueDate, ITaskCard } from "./task-card";
import { cloneDeep, isEqual } from "lodash";
import {
  defaultMyTaskDrawerConfig,
  SET_MY_TASK_DRAWER_CONFIG_OPTIONS,
  SET_MY_TASK_DRAWER_SCROLL_CONFIG_OPTIONS,
  SET_MY_TASK_WIDGET_CONFIG_OPTIONS,
} from "./reducers/user-task-card-view-reducer";
import dxDrawer from "devextreme/ui/drawer";
import { MyTaskTimePeriodEnum } from "./component";
import MdaeAccordion from "../common_widgets/accordion";
interface IUserTaskCardViewDrawerProps {
  drawerTitle: string;
  totalNumberOfDrawers: number;
  drawerDataCount: number;
  drawerType: string;
  kanbanDataList: any;
  myTaskDrawerId: string;
  myTaskWidgetId: string;
  myTaskRequestObject?: any;
  isFromMyTaskDashboardWidget?: any;
  refreshListHandler?: any;
  isExternalUser?:boolean;
}

const UserTaskCardViewDrawer: React.FC<IUserTaskCardViewDrawerProps> = (props) => {
  const taskList: Array<any> = props.kanbanDataList;
  const dispatch = useDispatch();
  let myTaskDrawerConfig = useSelector(
    (state) => state["myTaskReducer"].myTaskDrawerConfig,
    (left, right) => {
      if (isEqual(left[props.myTaskDrawerId], right[props.myTaskDrawerId])) {
        return true;
      }
      return false;
    }
  );
  let myTaskWidgetConfig = useSelector(
    (state) => state["myTaskReducer"].myTaskWidgetConfig,
    (left, right) => {
      if (isEqual(left[props.myTaskWidgetId], right[props.myTaskWidgetId])) {
        return true;
      }
      return false;
    }
  );
  const [drawerScrollBarInstance, setDrawerScrollBarInstance] = useState(null);
  myTaskWidgetConfig = myTaskWidgetConfig[props.myTaskWidgetId];
  myTaskDrawerConfig = myTaskDrawerConfig[props.myTaskDrawerId];
  const onToggleUserTaskDrawer = () => {
    let isDrawerOpened = myTaskDrawerConfig?.isOpened;
    isDrawerOpened = !isDrawerOpened;
    dispatch({
      type: SET_MY_TASK_DRAWER_CONFIG_OPTIONS,
      data: {
        myTaskDrawerId: props.myTaskDrawerId,
        isOpened: isDrawerOpened,
        isVisible: isDrawerOpened,
      },
    });
    let newMyTaskWidgetConfig = cloneDeep(myTaskWidgetConfig);
    if (isDrawerOpened) {
      newMyTaskWidgetConfig.totalCollapsedDrawers -= 1;
    } else {
      newMyTaskWidgetConfig.totalCollapsedDrawers += 1;
    }
    dispatch({
      type: SET_MY_TASK_WIDGET_CONFIG_OPTIONS,
      data: { ...myTaskWidgetConfig },
    });
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    });
  };
  setTimeout(() => {
    window.dispatchEvent(new Event("resize"));
  });
  const accordianDataSource = [];
  if (myTaskWidgetConfig?.isGroupByApplied) {
    for (var prop in taskList) {
      accordianDataSource.push(prop);
    }
    accordianDataSource.sort((a, b) => {
      if (
        new Date(taskList[a][0].dueDate).getTime() <
        new Date(taskList[b][0].dueDate).getTime()
      ) {
        return -1;
      }
      if (
        new Date(taskList[a][0].dueDate).getTime() >
        new Date(taskList[b][0].dueDate).getTime()
      ) {
        return 1;
      }
      return 0;
    });
  }

  const getGroupByAccordionTitle = (itemData) => {
    let titleText;
    let dueDate;
    if (taskList[itemData][0].myTaskGroupByEntityName) {
      titleText =
        itemData +
        " (" +
        taskList[itemData].length +
        " Task" +
        (taskList[itemData].length === 1 ? "" : "s") +
        ")";
      dueDate =
        "Next Due: " + GetFormatedDueDate(taskList[itemData][0].dueDate);
    }
    return { dueDate: dueDate, titleText: titleText };
  };
  if (myTaskDrawerConfig?.refreshScrollPosition) {
    setTimeout(() => {
      dispatch({
        type: SET_MY_TASK_DRAWER_SCROLL_CONFIG_OPTIONS,
        data: {
          myTaskDrawerId: props.myTaskDrawerId,
          isNotRefresh: true,
        },
      });
    });
  }

  return (
    <>
      <MdaeDrawer
        opened={myTaskDrawerConfig?.isOpened}
        visible={myTaskDrawerConfig?.isVisible}
        height={"90%"}
        elementAttr={{ style: "margin-right:15px;" }}
        id={""}
        onContentReady={(e) => {
          const drawerInstance = e.component;
          var isDrawerOpened = drawerInstance.option("opened");
          if (isDrawerOpened) {
            drawerInstance.option("width", "calc(25% - 10px)");
          } else {
            drawerInstance.option("width", 60);
          }

          $(drawerInstance.element())
            .find(".dx-drawer-panel-content")
            .addClass("user-task-kanban-drawer-panel-content");
          const getDrawerWidth = function() {
            var totalNumberOfDrawers = props.totalNumberOfDrawers;
            var widthPercent = 0;
            if (totalNumberOfDrawers === 0) {
              widthPercent = 100;
            } else {
              widthPercent = 100 / totalNumberOfDrawers;
            }
            return "calc(" + widthPercent + "% - 10px)";
          };
          const getCollapsedDrawerCount = (drawers) => {
            var totalDrawerCount = 0;
            for (var i = 0; i < drawers.length; i++) {
              var tempDrawerInstance = dxDrawer.getInstance($(drawers[i]) as any);
              if (tempDrawerInstance && !tempDrawerInstance.option("opened"))
                totalDrawerCount += 1;
            }
            return totalDrawerCount;
          };
          const resizeTheDrawerContainer = function() {
            try {
              var drawerInstance = e.component;
              var isDrawerOpened = drawerInstance.option("opened");
              if (isDrawerOpened) {
                drawerInstance.option("width", "calc(25% - 10px)");
                setTimeout(function() {
                  $(e.component.element())
                    .find(".dx-drawer-panel-content")
                    .css("width", "100%");
                });
              } else {
                drawerInstance.option("width", 60);
              }
              const kanbanParentDiv = $(e.component.element()).parents(
                ".user-task-kanban-parent"
              )[0];

              const fullWindowHeight = window.innerHeight - 40 - 56 - 60;
              var drawers = $(kanbanParentDiv).find(".dx-drawer");
              const totalCollapsedDrawerCount = getCollapsedDrawerCount(
                drawers
              );
              if (drawers && drawers.length) {
                for (var i = 0; i < drawers.length; i++) {
                  var tempDrawerInstance = dxDrawer.getInstance($(drawers[i]) as any);

                  $(tempDrawerInstance.element())
                    .find(".user-task-cards-scrollable-list")
                    .height(fullWindowHeight);
                  if (tempDrawerInstance) {
                    var tempIsDrawerOpened = tempDrawerInstance.option(
                      "opened"
                    );
                    if (tempIsDrawerOpened) {
                      var widthPercent;
                      if (totalCollapsedDrawerCount > 0) {
                        widthPercent =
                          100 /
                          (props.totalNumberOfDrawers -
                            totalCollapsedDrawerCount);
                        widthPercent =
                          "calc(" +
                          widthPercent +
                          "% - " +
                          (totalCollapsedDrawerCount * 75) /
                            (props.totalNumberOfDrawers -
                              totalCollapsedDrawerCount) +
                          "px)";
                      } else widthPercent = getDrawerWidth();

                      $(tempDrawerInstance.element()).css(
                        "width",
                        widthPercent
                      );
                      $(drawers[i])
                        .find(".dx-drawer-panel-content")
                        .css("width", "100%");
                    }
                  }
                }
              }
            } catch (e) {}
          };
          window.addEventListener("resize", resizeTheDrawerContainer);
        }}
        render={() => {
          return (
            <div>
              <div className={"user-task-drawer-template-container"}></div>
              <div
                className={
                  "row application-section-primary-background-color remove-margin user-task-drawer-toolbar-section-conatiner"
                }
              >
                <div
                  className={
                    "col-xs-12 application-section-primary-color user-task-drawer-toolbar-conatiner"
                  }
                >
                  <div className={"user-task-drawer-title-container"}>
                    {props.drawerTitle}
                    {props.drawerType === MyTaskTimePeriodEnum.Completed && (
                      <i
                        title="Showing all tasks completed in the past year"
                        className="fa fa-info-circle"
                        style={{
                          color: "white",
                          marginLeft: "10px",
                          cursor: "pointer",
                        }}
                      ></i>
                    )}
                  </div>
                  {!props.isFromMyTaskDashboardWidget && (
                    <div>
                      <div
                        className={"user-task-drawer-toolbar-collapse-button"}
                      >
                        <img
                          onClick={onToggleUserTaskDrawer}
                          src={
                            "/images/ui-rewrite-icons/drawermenubackbuttonwhiteicon.svg"
                          }
                          alt={"Mdae Menu"}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className={"user-task-kanban-container"}>
                <MdaeScrollView
                  onInitialized={(e) => {
                    setDrawerScrollBarInstance(e.component);
                  }}
                  elementAttr={{
                    myTaskDrawerScrollViewId: props.myTaskDrawerId,
                  }}
                  direction={"vertical"}
                  showScrollbar={"always"}
                  width={"98%"}
                  height={"98%"}
                  onScroll={(e) => {
                    try {
                      console.log(e.component.scrollTop());
                      JSON.stringify(e.event);
                      dispatch({
                        type: SET_MY_TASK_DRAWER_SCROLL_CONFIG_OPTIONS,
                        data: {
                          myTaskDrawerId: props.myTaskDrawerId,
                          mdaeScrollTop: {
                            left: 0,
                            top: e.component.scrollTop(),
                          },
                        },
                      });
                    } catch (e) {}
                  }}
                  mdaeDataUpdaterConfig={[
                    {
                      actionType: SET_MY_TASK_DRAWER_SCROLL_CONFIG_OPTIONS,
                      reducerName: "myTaskReducer",
                      widgetOptionBindings: {
                        mdaeScrollTop: "mdaeScrollTop",
                      },
                    },
                  ]}
                  className={"user-task-cards-scrollable-list"}
                >
                  <MdaeKanban
                    className={"user-task-sortable-cards"}
                    allowDropInsideItem={false}
                    allowReordering={false}
                    moveItemOnDrop={false}
                    handle={"undefined"}
                  >
                    {myTaskWidgetConfig?.isGroupByApplied && (
                      <MdaeAccordion
                        dataSource={accordianDataSource}
                        animationDuration={300}
                        collapsible={true}
                        elementAttr={{ class: "user-task-group-accordion" }}
                        multiple={false}
                        onItemTitleClick={(e) => {
                          setTimeout(() => {
                            var items = $(e.element).find(".dx-accordion-item");
                            items.each((i) => {
                              if (
                                $(items[i]).hasClass("dx-accordion-item-opened")
                              ) {
                                $(items[i])
                                  .find(
                                    ".user-task-kanban-grou-accordion-title-due-date"
                                  )
                                  .hide();
                              } else {
                                $(items[i])
                                  .find(
                                    ".user-task-kanban-grou-accordion-title-due-date"
                                  )
                                  .show();
                              }
                            });
                          });
                        }}
                        onContentReady={(e) => {
                          setTimeout(function(i) {
                            $(e.element)
                              .find(".dx-accordion-item")
                              .each(function(i) {
                                const items = e.component.option("items");
                                var currentItem = items[i];
                                const isEaLevelTaskPresent =
                                  taskList[currentItem]?.filter(
                                    (x) =>
                                      x.myTaskGroupByEntityName?.toLowerCase() ===
                                      "ea"
                                  )?.length > 0;
                                const isMaintenanceLevelTaskPresent =
                                  taskList[currentItem]?.filter(
                                    (x) =>
                                      x.myTaskGroupByEntityName?.toLowerCase() ===
                                      "mt"
                                  )?.length > 0;
                                $(this)
                                  .find(".dx-accordion-item-title")
                                  .addClass(
                                    "user-task-kanban-group-accordion-title-container"
                                  )
                                  .addClass(
                                    "user-task-card-group-" +
                                      (isEaLevelTaskPresent
                                        ? "ea"
                                        : isMaintenanceLevelTaskPresent
                                        ? "mt"
                                        : "au") +
                                      "-backgroun-color"
                                  );
                                $(this).addClass(
                                  "user-task-group-accordion-item"
                                );
                                if (
                                  $(this).hasClass("dx-accordion-item-opened")
                                ) {
                                  $(this)
                                    .find(
                                      ".user-task-kanban-grou-accordion-title-due-date"
                                    )
                                    .hide();
                                } else {
                                  $(this)
                                    .find(
                                      ".user-task-kanban-grou-accordion-title-due-date"
                                    )
                                    .show();
                                }
                              });
                            setTimeout(() => {
                              dispatch({
                                type: SET_MY_TASK_DRAWER_SCROLL_CONFIG_OPTIONS,
                                data: {
                                  myTaskDrawerId: props.myTaskDrawerId,
                                  isNotRefresh: true,
                                },
                              });
                            }, 500);
                          });
                        }}
                        itemRender={(itemData) => {
                          return taskList[itemData].map((x) => {
                            return (
                              <TaskCard
                                key={"pnlUserTaskCardItem" + x?.userTaskId}
                                isGroupByApplied={
                                  myTaskWidgetConfig?.isGroupByApplied
                                }
                                refreshListHandler={props.refreshListHandler}
                                groupByPropertyName={
                                  myTaskWidgetConfig?.groupByPropertyName
                                }
                                myTaskRequestObject={props.myTaskRequestObject}
                                drawerConfig={{ drawerType: props.drawerType }}
                                isFromMyTaskDashboardWidget={
                                  props.isFromMyTaskDashboardWidget
                                }
                                {...x}
                                myTaskDrawerId={props.myTaskDrawerId}  
                                isExternalUser={props.isExternalUser}                             
                              ></TaskCard>
                            );
                          });
                        }}
                        itemTitleRender={(itemData) => {
                          return (
                            <div
                              className={
                                props.drawerType !=
                                MyTaskTimePeriodEnum.Completed
                                  ? ""
                                  : "user-task-accordion-title-text-center"
                              }
                            >
                              <div
                                className={
                                  "user-task-kanban-group-accordion-title-text"
                                }
                                title={
                                  getGroupByAccordionTitle(itemData)?.titleText
                                }
                              >
                                {getGroupByAccordionTitle(itemData)?.titleText}
                              </div>
                              {props.drawerType !=
                                MyTaskTimePeriodEnum.Completed && (
                                <div
                                  className={
                                    "user-task-kanban-grou-accordion-title-due-date"
                                  }
                                >
                                  {getGroupByAccordionTitle(itemData)?.dueDate}
                                </div>
                              )}
                            </div>
                          );
                        }}
                      ></MdaeAccordion>
                    )}
                    {!myTaskWidgetConfig?.isGroupByApplied &&
                      taskList.map((x) => {
                        return (
                          <TaskCard
                            key={"pnlUserTaskCardItem" + x?.userTaskId}
                            isGroupByApplied={
                              myTaskWidgetConfig?.isGroupByApplied
                            }
                            refreshListHandler={props.refreshListHandler}
                            groupByPropertyName={
                              myTaskWidgetConfig?.groupByPropertyName
                            }
                            myTaskRequestObject={props.myTaskRequestObject}
                            drawerConfig={{ drawerType: props.drawerType }}
                            isFromMyTaskDashboardWidget={
                              props.isFromMyTaskDashboardWidget
                            }
                            {...x}
                            myTaskDrawerId={props.myTaskDrawerId}
                            isExternalUser={props.isExternalUser}     
                          ></TaskCard>
                        );
                      })}
                  </MdaeKanban>
                </MdaeScrollView>
              </div>
            </div>
          );
        }}
      ></MdaeDrawer>
      {myTaskDrawerConfig?.isVisible === false && (
        <div
          className={
            "application-section-primary-background-color user-task-drawer-collapsed-view-container"
          }
        >
          <div
            role={"button"}
            className={"user-task-expand-button-container"}
            onClick={onToggleUserTaskDrawer}
          >
            <div className={"expand-dx-button"}>
              <img
                className={"user-task-drawer-collapsed-view-expand-icon"}
                src={
                  "/images/ui-rewrite-icons/drawermenubackbuttonwhiteicon.svg"
                }
                alt={""}
              />
            </div>
          </div>
          <div>
            <div
              className={
                "application-section-primary-background-color user-task-drawer-title"
              }
            >
              {props.drawerTitle}
              {props.drawerType === MyTaskTimePeriodEnum.Completed && (
                <i
                  title="Showing all tasks completed in the past year"
                  className="fa fa-info-circle"
                  style={{
                    color: "white",
                    marginLeft: "10px",
                    cursor: "pointer",
                  }}
                ></i>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default UserTaskCardViewDrawer;
